import React from "react";
import styles from "./topicsitemwriter.module.scss";

type Props = {
  //img: string;
  name: string;
};
export const TopicsItemWriter: React.FC<Props> = (props) => {
  const { name } = props;

  return (
    <div className={styles["topics_writer"]}>
      <h2 className={styles["topics_writer_title"]}>この記事を書いた人</h2>
      <div className={styles["topics_writer_person"]}>
        <span className={styles["topics_writer_person_name"]}>{name}</span>
      </div>
    </div>
  );
};

export default TopicsItemWriter;
